import * as React from 'react';
import {MenuItem as MuiMenuItem, MenuItemProps} from '@mui/material';

const MenuItem = (props: MenuItemProps) => {

  return (
      <MuiMenuItem {...props} />
  );
}
export default MenuItem;